import axios from 'axios';
import { queryCache, useMutation } from 'react-query';

const deleteSet = ({ setId }) => {
  return axios.delete(`/api/v3/sets/${setId}`);
};

const useDeleteSet = () => {
  return useMutation(deleteSet, {
    onSuccess: () => {
      // Invalidate all sets queries to ensure table updates
      queryCache.invalidateQueries(['sets']);
    },
    onError: (error: any) => {
      console.error(`ERROR! ${error}`);
    }
  });
};

export default useDeleteSet;